import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastService } from './Toast.service';

@Component({
  selector: 'app-toasters',
  standalone: true,
  imports: [ToastModule],
  templateUrl: './toasters.component.html',
  styleUrl: './toasters.component.scss',
  providers: [MessageService]
})
export class ToastersComponent {
  constructor(private toastService: ToastService, private messageService: MessageService) {
    // Subscribe to toast events from the service
    this.toastService.toastMessages$.subscribe(message => {
      this.messageService.add(message);
    });
  }

}
